<template>
  <v-app style="zoom: 75%;">
    <v-main>
      <div class="top-overlay"></div>
        <v-parallax
          class="fixed-background"
          :style="{
            backgroundImage: `url(${isDark ? darkBg : lightBg})`
          }"
        />
      <div class="main-content">
        <NavigationBar/>
        <router-view/>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue'
import { useTheme } from 'vuetify'
import { computed } from 'vue'
import lightBg from '/assets/img/bg-App.jpg'
import darkBg from '/assets/img/bg-App_dark.jpg'


export default {
  components: {
    NavigationBar,
  },

  setup() {
    const theme = useTheme()
    const isDark = computed(() => theme.global.name.value === 'dark')

    return {
      isDark,
      lightBg,
      darkBg
    }
  }
}

</script>

<style scoped>
.fixed-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  z-index: 0;
}
.top-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 15px; /* Höhe des Bereichs, der überdeckt */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), transparent);
  backdrop-filter: blur(4px); /* Glassmorphismus */
  z-index: 2000; /* Höher als AppBar */
  pointer-events: all; /* Blockieren von Klicks */
}

.main-content {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  margin-top: 2px;
}
</style>
